module.exports = __webpack_public_path__ + "static/media/fb-color.b2e7674d.svg";